// UK phone + postcode validators shared by frontend.

// UK phone: accepts 07xxx xxxxxx, 01/02/03 landlines, and +44 international form.
// Strategy: strip spaces / dashes / parens, then match a canonical set.
const UK_PHONE_RE = /^(?:\+447\d{9}|07\d{9}|\+44[1-3]\d{8,9}|0[1-3]\d{8,9})$/;

export function normalizePhone(raw) {
  return (raw || "").replace(/[\s()\-.]/g, "");
}

export function isValidUKPhone(raw) {
  const cleaned = normalizePhone(raw);
  return UK_PHONE_RE.test(cleaned);
}

// UK postcode — accepts formats like SW1A 1AA, EC1A 1BB, M1 1AE, PE1 1AA.
// Ref: BS 7666 / Royal Mail simplified pattern.
const UK_POSTCODE_RE = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i;

export function normalizePostcode(raw) {
  const s = (raw || "").trim().toUpperCase();
  // Ensure a single space before the last 3 characters if missing.
  const compact = s.replace(/\s+/g, "");
  if (compact.length < 5) return s;
  return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
}

export function isValidUKPostcode(raw) {
  return UK_POSTCODE_RE.test((raw || "").trim());
}
